import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { Enrollment } from "@customTypes/masterclass";

import { masterclassQKeys } from "./queryKeys";

interface GetEnrollmentsProps {
  masterclassId?: string;
  isEnabled?: boolean;
}

export const useGetEnrollments = ({
  masterclassId,
  isEnabled = true,
}: GetEnrollmentsProps = {}) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: masterclassId 
      ? masterclassQKeys.enrollmentsByClass(masterclassId)
      : masterclassQKeys.enrollments(),
    queryFn: async () => {
      if (!masterclassId) return [];
      
      const { data } = await api.get<Enrollment[]>(`masterclass/${masterclassId}/enrollments/`);
      return data;
    },
    enabled: isEnabled && !!masterclassId,
    onError: (res: any) => {
      console.error("[From Get Enrollments]", res);
      handleErrors(res, "query");
    },
  });
};
